import React from 'react';

/**
 * TrolyWordmark — logotipo oficial Onyx Club.
 *
 * Props:
 *   inverse   boolean   true → texto en mist (fondo oscuro)
 *                       false → texto en onyx (fondo claro)
 *   size      number|string  tamaño de fuente (default 4rem)
 *   className string    clases extra
 *   as        string    tag HTML (default 'span')
 */
export default function TrolyWordmark({
  inverse = false,
  size = '4rem',
  className = '',
  as: Tag = 'span',
  ...rest
}) {
  const baseStyle = {
    fontFamily: 'var(--troly-font-display)',
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: size,
    lineHeight: 1,
    letterSpacing: '-0.01em',
    color: inverse ? '#F2EFE9' : '#0E1116',
    fontFeatureSettings: '"kern" 1, "liga" 1',
    WebkitFontSmoothing: 'antialiased',
    textRendering: 'optimizeLegibility',
    display: 'inline-block',
  };

  const dotStyle = {
    color: '#45E6C2',
    fontWeight: 'inherit',
  };

  return (
    <Tag
      className={`troly-wordmark${inverse ? ' troly-wordmark--inverse' : ''}${className ? ' ' + className : ''}`}
      style={baseStyle}
      {...rest}
    >
      Troly
      <span className="troly-wordmark__dot" style={dotStyle}>.</span>
    </Tag>
  );
}
